import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { decodeToken } from '../../Services/DecodeToken';
import Login from './Login';

export const RootRouteRedirect: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const validate = async () => {
      const result = await decodeToken();
      setAuthorized(result.authorized);
      setLoading(false);
    };
    validate();
  }, []);

  if (loading) return <div>Loading...</div>;

  if (authorized) return <Navigate to="/home" replace />;
  return <Login />;
};
